export const onlyDigitsPipe = (str: string): string => {
  if (!str) {
    return '';
  }
  return str.replace(/\D/g, '');
};
